import { debug } from 'debug';
import { DataModel, Handler, Result, ok, err, ComplexModel, SimpleModel } from './handler';
import { Path } from './path';
import { SchemaError, ErrorCode } from './schema-error';
import { simple, SimpleType } from './simple';

const d = debug('attribute');

export function rwAttrib(
  getter: ((data: SimpleModel) => Result<string, SchemaError>) | null,
  setter: ((data: SimpleModel, value: string) => Result<SimpleModel, SchemaError>) | null,
  ...path: string[] ): ComplexAttribute {

  const selector = (x: ComplexModel) => x.getIn(path);
  const injector = (data: ComplexModel, newMember: DataModel) => data.setIn(path, newMember);

  const attribute = new ComplexAttribute(
    simple(SimpleType.readWrite, getter, setter),
    selector,
    injector
  );

  return attribute;
}

export function roAttrib(
  getter: ((data: SimpleModel) => Result<string, SchemaError>) | null,
  ...path: string[]): ComplexAttribute {

      const selector = (x: ComplexModel) => x.getIn(path);

      const attribute = new ComplexAttribute(
        simple(SimpleType.readOnly, getter, null),
        selector,
        null
      );

      return attribute;
    }

export function woAttrib(
  setter: ((data: SimpleModel, value: string) => Result<SimpleModel, SchemaError>) | null,
  ...path: string[]): ComplexAttribute {

      const selector = (x: ComplexModel) => x.getIn(path);
      const injector = (data: ComplexModel, newMember: any) => data.setIn(path, newMember);

      const attribute = new ComplexAttribute(
        simple(SimpleType.writeOnly, null, setter),
        selector,
        injector);

      return attribute;
    }

export class ComplexAttribute implements Handler {

  constructor(
    private child: Handler,
    private selector: (data: ComplexModel) => DataModel,
    private injector: ((data: ComplexModel, newMember: any) => ComplexModel) | null) {


  }

  public get(path: Path, data: any): Result<string, SchemaError> {

    const selectedData = this.selector(data);
    return this.child.get(path.next(), selectedData);
  }

  public set(path: Path, current: ComplexModel, value: string): Result<ComplexModel, SchemaError> {

    if (!this.injector) {
      return err(new SchemaError(ErrorCode.elementIsReadOnly, 'It is read only'));
    }

    let selectedData: any;
    try {
      selectedData = this.selector(current);
    } catch (err) {
      d('Error occurred in complex selector.', path, current);
      throw err;
    }

    const newData = this.child.set(path.next(), selectedData, value);
    if (!newData.success) {
      return newData;
    }

    const injected = this.injector(current, newData.value as any);
    return ok(injected);
  }

}
